import { Card } from "../ui/card.tsx"
import { Button } from "../ui/button.tsx"

export function PerformanceCard() {
  const classes = [
    { name: "SS 1A", progress: 40 },
    { name: "SS 2B", progress: 85 },
    { name: "JSS 1A", progress: 65 },
    { name: "JSS 3B", progress: 90 },
  ]

  return (
    <Card className="p-6">
      <div className="mb-4 flex items-center justify-between">
        <h3 className="font-semibold">Performance</h3>
        <div className="text-3xl font-bold text-green-500">85%</div>
      </div>

      <div className="space-y-4">
        {classes.map((cls) => (
          <div key={cls.name}>
            <div className="mb-2 flex items-center justify-between text-sm">
              <span>{cls.name}</span>
            </div>
            <div className="h-2 rounded-full bg-gray-100">
              <div className="h-full rounded-full bg-purple-600" style={{ width: `${cls.progress}%` }} />
            </div>
          </div>
        ))}
      </div>

      <Button variant="ghost" size="sm" className="mt-4 w-full">
        All Classes
      </Button>
    </Card>
  )
}

